import React, { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { captureError } from '@/services/error-sender';
import errorIconObject from './assets/error-icon.svg';
import styles from './error-boundary.module.scss';

const errorIcon = errorIconObject.src;

const ErrorBoundary = (props: {
  error: Error & { digest?: string; };
}) => {
  useEffect(() => {
    captureError(props.error, ['error-boundary']);
  }, [props.error]);

  useEffect(() => {
    const errorMessage = props.error.toString();
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(window.sessionStorage.getItem('page-has-been-force-refreshed') || 'false');

    // Якщо помилка пов'язана з завантаженням чанку один раз перезавантажити сторінку
    if (
      !pageHasAlreadyBeenForceRefreshed
      && (errorMessage.includes('Loading CSS chunk')
      || errorMessage.includes('Loading chunk'))
    ) {
      window.sessionStorage.setItem('page-has-been-force-refreshed', 'true');

      window.location.reload();
    } else {
      window.sessionStorage.removeItem('page-has-been-force-refreshed');
    }
  }, [props.error]);

  const getErrorId = () => {
    const lastEventId = Sentry.lastEventId();

    if (lastEventId) return lastEventId;
    return Sentry.captureException(props.error);
  };

  return (
    <div className={styles['error-boundary']}>
      <img src={errorIcon} alt="" className={styles.icon} />
      <h3 className={styles.title}>Ooops!</h3>
      <h4 className={styles.descr}>Something went wrong...</h4>
      <p className={styles.error}>{`Error code: ${getErrorId()}`}</p>
      <button className={styles.button} type="button" onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
};

export default ErrorBoundary;
